   <div>
        <mat-toolbar class="top_headerbar">
          <div class="left" [ngClass]="{ show: shouldShow, hide: !shouldShow }">
            <span *ngIf="hideItemsFromAssets" class="custom_select_outer">
              <select class="custom_select form-control width_180" #mySelect (change)="onSiteSelected(mySelect.value)">
                <option value="0">All Sites</option>
                <option value="{{ site.id }}" *ngFor="let site of sitesList">
                  {{ site.name }}
                </option>
              </select>
            </span>
            <span *ngIf="hideItemsFromAssets" class="custom_select_outer">
              <select class="custom_select form-control width_180" #groupSelect
                (change)="onGroupSelected(groupSelect.value)">
                <option value="0">All Applications</option>
                <option value="{{ group.id }}" *ngFor="let group of groupList; let idx = index">
                  {{ group.name }}
                </option>
              </select>
            </span>
            <span class="custom_select_outer">
              <select class="custom_select form-control width_180" #assetsSelect>
                <option value="ALL">All Assets</option>
                <option value="OFFLINE">Offline</option>
                <option value="HEALTHY">Healthy</option>
                <option value="UNHEALTHY">Unsatisfactory</option>
                <option value="ERROR">Unacceptable</option>
              </select>
            </span>
          </div>
        </mat-toolbar>
        <div class="col-md-12">
            <div class="no_result" *ngIf="emptyMsg">
                <h4>No device added yet</h4>
            </div>
        </div>
        <div class="row col-md-12" style="padding: 40px 10px;">
            <div class="col-md-3 outer_div"  *ngFor="let roomData of eBoilerRoomListData" style="border: 1px solid;">
                <div class="" style="float: right;">
                    <button class="btn top_margin" type="button" [matMenuTriggerFor]="menu" data-toggle="dropdown" >
                      <span class="sprite_icon ellipse_black"></span>
                    </button>
                    <mat-menu #menu="matMenu">
                      <div class="client_action" 
                      style="
                      display: grid;
                      padding-left: 5px;
                      gap: 4px;
                      padding-top: 5px;
                      padding-bottom: 5px;
                    ">
                        <button  mat-stroked-button color="primary" (click)="editConfigurator(roomData.id, roomData.subsystem_name, roomData.site_name, roomData.application_name)"> <mat-icon>info</mat-icon> Edit</button>
                        <button mat-stroked-button color="warn" (click)="deleteBoilerFun(roomData.id, roomData.gateway_address)"><mat-icon>delete</mat-icon> Delete</button>
                      </div>
                    </mat-menu>
                </div>
                <div class="text-center"  (click)="openBoilerRoom(roomData.id, roomData.subsystem_name)">
                        <img src="./assets/products-coil-tube-steam-boiler.png" alt="">
                        <h5>{{roomData.subsystem_name}}</h5>
                </div>
            </div>
        </div>
       
        
    </div>

   
  
        
